import * as React from "react";
import Image from "next/image";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import EvervaultCard from "../evault-card";

type TechStackImagesData = {
  id: number;
  src: string;
  alt: string;
  bgColor: string;
};

type TechStackCardProps = {
  data: TechStackImagesData;
};

/**
 * Renders a tech stack card with an image and a title
 *
 * @param data - The data for the tech stack card
 */
const TechStackCard: React.FC<TechStackCardProps> = ({ data: i }) => {
  const containerRef = React.useRef<HTMLParagraphElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      containerRef.current,
      { opacity: 0, y: 30 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: i.id * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top bottom",
        },
      }
    );
  }, [i.id]);

  const imageStyles = `
    ease-in-out-quad aspect-square md:translate-y-4 md:scale-105 scale-100 object-contain brightness-105 md:grayscale transition duration-300 md:group-hover:translate-y-0 md:group-hover:scale-100 md:group-hover:grayscale-0 md:scale-125 md:group-hover:scale-100
  `;

  return (
    <div
      ref={containerRef}
      className="border-primary-50/20 group relative flex h-[140px] items-center justify-center border md:h-[200px]"
    >
      <div className="absolute inset-0">
        <EvervaultCard bgColor={i.bgColor}>
          <div className="relative flex flex-col items-center justify-center gap-y-2 md:gap-y-3">
            <Image
              src={i.src}
              alt={i.alt}
              height={50}
              width={50}
              loading="lazy"
              className={imageStyles}
            />
            <span className="text-primary-50 ease-in-out-quad font-medium capitalize opacity-100 transition duration-300 sm:text-xl md:opacity-0 md:group-hover:opacity-100">
              {i.alt}
            </span>
          </div>
        </EvervaultCard>
      </div>
    </div>
  );
};

export default TechStackCard;
